import { MethodType } from '../constants/MethodType'

const api = require('./api')

export const fetchBankVerifyAResuestList = async (enterpriseId, params) => api.request(1, `/api/v3/enterprise/${enterpriseId}/verification/`, MethodType.GET, params)

export const verifyBankAccounts = async (enterpriseId, params) => api.request(1, `/api/v3/enterprise/${enterpriseId}/verification/verify/`, MethodType.PATCH, params)

export const modVerification = async (enterpriseId, params) => api.request(1, `/api/v3/enterprise/${enterpriseId}/verification/updates/`, MethodType.PATCH, params)
